import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  Pagination,
  FormControl,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import {
  ViewConsultations,
  GetDocAllUser,
  searchLeadByName,
  rechargePayment,
  DownloadConsultationInvoice,
  getCallLogsById,
} from "../../../Listfunction";
import { Link } from "react-router-dom";
import Card from "components/Card/Card.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import Button from "components/CustomButton/CustomButton.jsx";
import ReactTable from "react-table";
import LoadingSpinner from "views/Components/loadingSpinner";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import Select from "react-select";
import moment from "moment";

class Consultation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      docotor_id: "",
      patient_id: "",
      consultation_mode: "",
      patient_list: [],
      call_ended_type: "",
      doctors: [],
      consultationList: [],
      page: 1,
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      //tabledata: "",
      loading: false,
      _notificationSystem: null,
      //cardHidden: true,
      //alert: null,
      useraccess: "",
      noRecordFound: false,
      totpageNo: "",
      pdfloading: false,
      processing: true,
      showCallLogModal: false,
      callLogsData: [],
    };
    this.scrollTopEl = React.createRef();
    this.onChange = this.onChange.bind(this);
    this.SearchDate = this.SearchDate.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
  }

  resetSearch(e) {
    this.setState({
      docotor_id: "",
      patient_id: "",
      consultation_mode: "",
      call_ended_type: "",
    });

    setTimeout(
      function () {
        this.SearchDate(1);
      }.bind(this),
      1000
    );
  }

  SearchDate = (page) => {
    this.scrollTopEl.current.scrollTop = 0;
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    var doc_id = "";
    var pat_id = "";
    if (this.state.docotor_id != "") {
      doc_id = this.state.docotor_id.value;
    }
    if (this.state.patient_id != "") {
      pat_id = this.state.patient_id.value;
    }

    ViewConsultations(
      obj,
      doc_id,
      pat_id,
      this.state.consultation_mode,
      this.state.call_ended_type,
      page
    )
      .then((res) => {
        if (res.success == true) {
          var data = res.data;

          var no_pages = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              no_pages.push(i);
            } else {
              no_pages.push(i);
            }
          }

          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.length == 0) {
            no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            } else {
              this.setState({
                nextpage: data.next_page_url.substring(
                  data.next_page_url.indexOf("=") + 1
                ),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1
                ),
              });
            } else {
              this.setState({
                prevpage: data.prev_page_url.substring(
                  data.prev_page_url.indexOf("=") + 1
                ),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }

          this.setState({ paginationData: no_pages });
          this.setState({
            loading: false,
            consultationList: res.data.data,
            totpageNo: data.last_page,
          });
        } else {
          this.handleNetworkError("bl");
        }
      })
      .catch((err) => {
        this.handleNetworkError("bl");
      });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSuccess(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{message}</div>,
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleClick(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>{message}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({
      useraccess: token.role,
    });

    GetDocAllUser(obj)
      .then((res) => {
        var users = res.data.data;
        var doc = [];

        for (let i = 0; i < users.length; i++) {
          if (users[i].role == 9) {
            var option = { value: users[i].id, label: users[i].name };
            doc.push(option);
          }
        }
        this.setState({ doctors: doc });
      })
      .catch((err) => {
        console.log(err);
      });

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );

    this.SearchDate(this.state.page);
  }

  handleChange = (e) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    searchLeadByName(e.target.value, obj).then((response) => {
      var data = response.data.data;
      var table_data = [];

      for (let i = 0; i < data.length; i++) {
        var detail = {
          value: data[i].id,
          label: data[i].lead_name,
        };
        table_data.push(detail);
      }
      this.setState({
        patient_list: table_data,
      });
    });
  };

  downloadinvoice = (id, fa_id) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ pdfloading: true, processing: false }, () => {
      DownloadConsultationInvoice(fa_id, id, obj).then((res) => {
        var ddata = res.data.data.pdf_url;
        const link = document.createElement("a");
        link.href = ddata;
        link.target = "_blank";
        link.setAttribute("download", "order_" + id + ".pdf");
        // document.body.appendChild(link)
        link.click();
        // this.setState({
        //   viewinvoice : ddata
        // })
        this.setState({ pdfloading: false, processing: true });
      });
    });
  };

  rechargeCunPayment = (id) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    rechargePayment(obj, id)
      .then((res) => {
        console.log(res.data);
        if (res.data.success == false) {
          this.handleClick("bl", "Decline - Your card has been expired.");
        } else {
          this.handleSuccess("bl", "Recharge Successful.");
        }
        this.SearchDate(this.state.page);
      })
      .catch(() => {
        this.handleNetworkError("bl");
      });
  };

  paginationinfo(url) {
    this.SearchDate(url);
  }

  openCallLoigModal(ConsultationId) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ showCallLogModal: true })

    getCallLogsById(obj, ConsultationId)
      .then((res) => {
        this.setState({ callLogsData: res.data.payload });
      })
      .catch(() => {
        this.handleNetworkError("bl");
      });

  }

  copyTheDeviceInfoDetails(deviceInfo) {
    const textFile = JSON.stringify(deviceInfo)
    navigator.clipboard.writeText(textFile)
    this.handleSuccess("tr", "Object Coppied.");

  }

  render() {
    var c = 1;
    console.log("this.state.callLogsData", this.state.callLogsData)
    // const deviceInfo = <Tooltip id="deviceInfo">{this.state.callLogsData.map((item)=>{return item.deviceInfo.deviceType})}</Tooltip>;

    return (
      <div className="main-content" ref={this.scrollTopEl}>
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <Row>
                    <Col className="consultation_filter_container">
                      <Row>
                        <Col
                          md={3}
                          sm={6}
                          className="consultation_filter_display"
                        >
                          <Select
                            style={{ textTransform: "capitalize" }}
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="docotor_id"
                            value={this.state.docotor_id}
                            onChange={(value) => {
                              this.setState({
                                docotor_id: value,
                              });
                            }}
                            options={this.state.doctors}
                            placeholder="Select Doctor"
                            noOptionsMessage={() => "No doctor found"}
                          />
                        </Col>
                        <Col
                          md={3}
                          sm={6}
                          className="consultation_filter_display"
                          onKeyUp={(e) => this.handleChange(e)}
                        >
                          <Select
                            style={{ textTransform: "capitalize" }}
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="patient_id"
                            value={this.state.patient_id}
                            onChange={(value) => {
                              this.setState({
                                patient_id: value,
                              });
                            }}
                            options={this.state.patient_list}
                            placeholder="Enter patient name"
                            noOptionsMessage={() => "No patient found"}
                          />
                        </Col>
                        <Col
                          md={3}
                          sm={6}
                          className="consultation_filter_display"
                        >
                          <select
                            name="consultation_mode"
                            placeholder="consultation_mode"
                            value={this.state.consultation_mode || ""}
                            onChange={this.onChange}
                            className="form-control"
                          >
                            <option value="">Select Consultation Mode</option>
                            <option value="1">Speak Now</option>
                            <option value="2">Scheduled</option>
                            <option value="3">Second Opinion</option>
                          </select>
                        </Col>
                        <Col
                          md={3}
                          sm={6}
                          className="consultation_filter_display"
                        >
                          <select
                            name="call_ended_type"
                            placeholder="call_ended_type"
                            value={this.state.call_ended_type || ""}
                            onChange={this.onChange}
                            className="form-control"
                          >
                            <option value="">Select Call End Type </option>
                            <option value="1">Dropped</option>
                            <option value="2">Consulted </option>
                            <option value="3">Incomplete consult</option>
                            <option value="4">Cancelled</option>
                          </select>
                        </Col>
                      </Row>
                      <Row style={{ paddingLeft: "15px" }}>
                        <Col>
                          <Button
                            class="btn-color" //bsStyle="info"
                            fill
                            onClick={this.SearchDate.bind(this, 1)}
                          >
                            Filter
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            class="btn-color" //bsStyle="info"
                            fill
                            onClick={this.resetSearch.bind(this)}
                          >
                            Reset
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={12} className="consultation_tabledate_container">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Consultation ID</th>
                            <th>Doctor</th>
                            {/* <th>Patient</th> */}
                            <th>Consultation Mode</th>
                            <th>Call End Type</th>
                            <th>Consultation DateTime</th>
                            <th>Med order id</th>
                            <th>Lab order id</th>
                            <th>Price</th>
                            <th>Invoice</th>
                            <th>Payment Status</th>
                            <th>Call Log</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colspan="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.consultationList.length == 0 ? (
                            <tr>
                              <td colspan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <React.Fragment>
                              {this.state.consultationList.map((cus, i) => (
                                <tr key={i}>
                                  <td>{cus.consultation_id}</td>
                                  <td
                                    key={cus.i}
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {cus.doctor && cus.doctor.name}
                                  </td>
                                  {/* <td>{cus.patient.name}</td> */}
                                  <td>
                                    {cus.consultation_mode == 1
                                      ? "Talk Now"
                                      : cus.consultation_mode == 2
                                        ? "Talk Later "
                                        : cus.consultation_mode == 3
                                          ? "Second Opinion"
                                          : "-"}
                                  </td>
                                  <td>
                                    {cus.call_ended_type == 1
                                      ? "Dropped"
                                      : cus.call_ended_type == 2
                                        ? "Consulted"
                                        : cus.call_ended_type == 3
                                          ? "Complete Consult"
                                          : cus.call_ended_type == 4
                                            ? "Cancelled"
                                            : "-"}
                                  </td>
                                  <td>{cus.end_time}</td>
                                  <td>{cus.med_order_id === 0 || cus.med_order_id === null ? "-" : cus.med_order_id}</td>
                                  <td>{cus.lab_order_id === 0 || cus.lab_order_id === null ? "-" : cus.lab_order_id}</td>
                                  <td>{cus.price}</td>
                                  <td>
                                    {" "}
                                    <Button //bsStyle="danger"
                                      disabled={!this.state.processing}
                                      onClick={() =>
                                        this.downloadinvoice(
                                          cus.id,
                                          cus.consultation_id
                                        )
                                      }
                                    >
                                      View
                                    </Button>
                                  </td>
                                  <td>
                                    {cus.payment_status != "failed" ? (
                                      cus.payment_status
                                    ) : (
                                      <>
                                        <p
                                          className="btn btn-fill fl_text_orange"
                                          onClick={() =>
                                            this.rechargeCunPayment(cus.id)
                                          }
                                        >
                                          Recharge
                                        </p>
                                      </>
                                    )}
                                  </td>
                                  <td>
                                    {" "}
                                    <Button //bsStyle="danger"
                                      disabled={!this.state.processing}
                                      onClick={() => this.openCallLoigModal(cus.consultation_id)}
                                    >
                                      View
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </React.Fragment>
                          )}
                        </tbody>
                      </Table>
                    </Col>
                    {this.state.loading
                      ? ""
                      : this.state.noRecordFound
                        ? ""
                        : this.state.totpageNo > 1 && (
                          <div style={{ textAlign: "center" }}>
                            <Pagination>
                              <Pagination.First
                                onClick={this.paginationinfo.bind(
                                  this,
                                  this.state.prevpage
                                )}
                                disabled={this.state.prevdisabled}
                              />
                              {this.state.paginationData.map((url) => (
                                <Pagination.Item
                                  active={
                                    this.state.currentPage == c ? "1" : null
                                  }
                                  onClick={this.paginationinfo.bind(this, url)}
                                >
                                  {c++}
                                </Pagination.Item>
                              ))}
                              <Pagination.Last
                                onClick={this.paginationinfo.bind(
                                  this,
                                  this.state.nextpage
                                )}
                                disabled={this.state.nextdisabled}
                              />
                            </Pagination>
                          </div>
                        )}
                  </Row>
                }
              />
            </Col>
          </Row>
        </Grid>
        <Modal
          show={this.state.showCallLogModal}
          onHide={() => this.setState({ showCallLogModal: false })}
          bsSize="lg"
        >
          <Modal.Header>
            <Modal.Title>Call Logs</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ overflowY: 'scroll', height: '70vh' }}>
            <Table>
              <thead>
                <th>Action</th>
                <th>Description</th>
                <th>Application</th>
                <th>DeviceInfo</th>
                <th>Date</th>
                <th>User</th>
                <th>Consultation</th>
              </thead>
              <tbody>
                {this.state.callLogsData.length === 0 ? (
                  <tr>
                    <td colSpan="10"><center>No data found....</center></td>
                  </tr>
                ) : (this.state.callLogsData && this.state.callLogsData.map((data) => (
                  <tr>
                    <td>{data.action === null ? "" : data.action}</td>
                    <td>{data.description === null ? "" : data.description}</td>
                    <td>{data.application === null ? "" : data.application}</td>
                    <td>
                      {data.deviceInfo !== null || undefined || "" ? (<OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="deviceInfo" >
                            {
                              <>
                                <p>Device type: {data.deviceInfo.deviceType !== null || "" ? data.deviceInfo.deviceType : ""}</p>
                                <p>Room socket connected: {data.deviceInfo.isRoomSocketConnected === true ? "yes" : "No"}</p>
                                <p>Socket connected: {data.deviceInfo.isSocketConnected === true ? "yes" : "No"}</p>
                                <p>Network type: {data.deviceInfo.deviceType !== null || "" ? data.deviceInfo.deviceType : ""}</p>
                                <p>OS version: {data.deviceInfo.osVersion !== null || "" ? data.deviceInfo.osVersion : ""}</p>
                              </>
                            }
                          </Tooltip>
                        }
                      >
                        <Button onClick={() => this.copyTheDeviceInfoDetails(data.deviceInfo)}>Copy</Button>
                      </OverlayTrigger>) : ""}
                    </td>
                    <td>{data.dateAndTime === null ? "" : moment(data.dateAndTime).format("YYYY-MM-DD hh:mm:ss")}</td>
                    <td>{data.user !== null || undefined || "" ? (<OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="user" >
                          {
                            <>
                              <p>Name: {data.user.name !== null || "" ? data.user.name : ""}</p>
                              <p>Email: {data.user.email !== null || "" ? data.user.email : ""}</p>
                              <p>Mobile No: {data.user.phoneNumber !== null || "" ? data.user.phoneNumber : ""}</p>
                              <p>Admin user Id: {data.user.adminUserId !== null || "" ? data.user.adminUserId : ""}</p>
                              <p>User Type: {data.user.userType !== null || "" ? data.user.userType : ""}</p>
                            </>
                          }
                        </Tooltip>
                      }
                    >
                      <Button style={{ border: 'none', margin: '0px', padding: '0px' }} onClick={() => this.copyTheDeviceInfoDetails(data.user)}>{data.user.name}</Button>
                    </OverlayTrigger>) : ""}</td>
                    <td>
                      {data.consultation !== null || undefined || "" ? (<OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="consultation" >
                            {
                              <>
                                <p>Consultation Id: {data.consultation.consultationId !== null || "" ? data.consultation.consultationId : ""}</p>
                                <p>Flash Consultation Id: {data.consultation.flashConsultationId !== null || "" ? data.consultation.flashConsultationId : ""}</p>
                                <p>Call Type: {data.consultation.callType !== null || "" ? data.consultation.callType : ""}</p>
                                <p>Doctor Name: {data.consultation.doctorName !== null || "" ? data.consultation.doctorName : ""}</p>
                                <p>Patient Name: {data.consultation.patientName !== null || "" ? data.consultation.patientName : ""}</p>
                              </>
                            }
                          </Tooltip>
                        }
                      >
                        <Button onClick={() => this.copyTheDeviceInfoDetails(data.consultation)}>Copy</Button>
                      </OverlayTrigger>) : ""}
                    </td>
                  </tr>
                )))}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} md={12} xs={12} className="text-right">
              <Button
                bsStyle="danger"
                fill
                onClick={() => this.setState({ showCallLogModal: false })}
              >
                Cancel
              </Button>
            </Col>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default Consultation;
